import { useState } from "react";

export default function useConfirmModal() {
  const [isOpen, setisOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [meta, setmeta] = useState<any>(undefined);

  const open = (data: any) => {
    setisOpen(true);
    setmeta(data?.meta !== undefined ? data.meta : data);
  };
  const close = () => {
    setmeta(undefined);
    setisOpen(false);
    setIsLoading(false);
  };
  return { isOpen, open, close, setisOpen, isLoading, setIsLoading, meta };
}
